import type UserResetPasswordProperties from './UserResetPassword.properties.ts';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { toastOptions } from '../../tools/helpers/ToastHelper.ts';
import type { UserUserResetPasswordInput } from '../../generated/fresh-guard-api';
import { useTranslation } from 'react-i18next';
import { useUserResetPassword } from '../../apis/user/useUserResetPassword.ts';
import { isPasswordLongEnough } from '../../tools/helpers/PasswordPolicy.ts';

export const useUserResetPasswordController = (props: UserResetPasswordProperties) => {
  const { t } = useTranslation();
  const [password, setPassword] = useState<string>('');
  const [repeatPassword, setRepeatPassword] = useState<string>('');

  const { mutate, isPending } = useUserResetPassword();

  const handleSave = () => {
    const userUserResetPasswordInput: UserUserResetPasswordInput = {
      username: props.user?.username,
      newPassword: password.trim(),
    };

    mutate(
      { userUserResetPasswordInput },
      {
        onSuccess: () => {
          toast.success(t('success.userSaved'), toastOptions);
          props.handleDialogCloseClick();
        },
      }
    );
  };

  const enableSaveButton = () => {
    return isPasswordLongEnough(password) && password === repeatPassword;
  };

  return {
    loading: isPending,
    handleSave,
    enableSaveButton,
    password,
    setPassword,
    repeatPassword,
    setRepeatPassword,
  };
};
